import { watch, onMounted, onUnmounted } from 'vue';
import CloseButton from './CloseButton.vue';


export default {
  __name: 'CalendarModal',
  props: {
    isOpen: Boolean,
    position: Object,
},
  emits: ['close'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props;





const closeModal = () => {
    emit('close');
};

const stopPropagation = (ev) => {
    ev.stopPropagation();
};

watch(
    () => props.isOpen,
    (newValue) => {
        document.body.style.overflow = newValue ? 'hidden' : 'auto';
    },
);

const __returned__ = { props, emit, closeModal, stopPropagation, watch, onMounted, onUnmounted, CloseButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}